//convert hex color to rgb

import { PORTAL_NAMES } from 'src/constants';
import httpheader from 'src/Member/shared/httpheader';

export * from './stateOptions';
export * from './genderOptions';
export * from './suffixOptions';
export * from './raceEthnicityOptions';
export * from './relationshipToInsuredOptions';

export function hexToRgb(hex) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
  throw new Error('Bad Hex');
}

export function getPortalName(userType) {
  //const url = window.location.href;
  const url = httpheader.getCNAME();
  if (
    url.includes('mybenefits.choosebywater.com') ||
    url.includes('roundstone')
  ) {
    return {
      mainHeadeing: PORTAL_NAMES.BYWATER.DEFAULT,
      subHeading: userType
        ? PORTAL_NAMES.BYWATER[userType?.toUpperCase()] || ''
        : '',
    };
  }
  if (url.includes('keenan') || url.includes('tpabenefits')) {
    return {
      mainHeadeing: PORTAL_NAMES.KEENAN.DEFAULT,
      subHeading: userType
        ? PORTAL_NAMES.KEENAN[userType?.toUpperCase()] || ''
        : '',
    };
  }
  if (url.includes('hub')) {
    return {
      mainHeadeing: PORTAL_NAMES.HUB.DEFAULT,
      subHeading: userType
        ? PORTAL_NAMES.HUB[userType?.toUpperCase()] || ''
        : '',
    };
  }
  return {
    mainHeadeing: PORTAL_NAMES.JAVELINA.DEFAULT,
    subHeading: userType
      ? PORTAL_NAMES.JAVELINA[userType?.toUpperCase()] || ''
      : '',
  };
}

export const formatPhoneNumber = (phone) => {
  if (phone) {
    const input = phone.replace(/\D/g, '').substring(0, 10);

    //Based upon the length of the string, we add formatting as necessary
    if (input.length == 0) {
      return input;
    } else if (input.length < 4) {
      return '(' + input;
    } else if (input.length < 7) {
      return '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
    } else {
      return (
        '(' +
        input.substring(0, 3) +
        ') ' +
        input.substring(3, 6) +
        ' ' +
        input.substring(6, 10)
      );
    }
  } else {
    return null;
  }
};
